import BaseRepository from './base.repository';

class FluidRepository extends BaseRepository {
  constructor() {
    super('/fluid');
  }

  getDashboard() {
    return this.client.get('');
  }

  getReadings(params) {
    return this.client.get('/readings', params);
  }

  getReading(mainUnique) {
    return this.client.get(`/readings/${mainUnique}`);
  }

  createReading(payload) {
    return this.client.post('/readings', payload);
  }

  updateReading(mainUnique, payload) {
    return this.client.patch(`/readings/${mainUnique}`, payload);
  }

  deleteReading(mainUnique) {
    return this.client.delete(`/readings/${mainUnique}`);
  }

  requestDryWeight(payload) {
    return this.client.post('/dry-weight-requests', payload);
  }

  getAttendance() {
    return this.client.get('/attendance');
  }

  saveAttendance(payload) {
    return this.client.post('/attendance', payload);
  }

  getReminders() {
    return this.client.get('/reminders');
  }

  createReminder(payload) {
    return this.client.post('/reminders', payload);
  }

  updateReminder(itemUnique, payload) {
    return this.client.patch(`/reminders/${itemUnique}`, payload);
  }

  deleteReminder(itemUnique) {
    return this.client.delete(`/reminders/${itemUnique}`);
  }

  getNotificationContext(params) {
    return this.client.get('/notification-context', params);
  }

  dismissAlert(itemUnique) {
    return this.client.post(`/alerts/${itemUnique}/dismiss`);
  }

  reviewDryWeight(prescriptionItemUnique, request) {
    return this.client.patch(`/dry-weight-updates/${prescriptionItemUnique}`, request);
  }
}

export default new FluidRepository();
